import React, { useEffect, useState } from 'react';
import {
  Button,
  Container,
  Table,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  Collapse,
} from 'reactstrap';
import { toast } from 'react-toastify';
// import Api from '../../../api';
import Loading from '../../../../shared/components/custom/Loading';
// import PersonCardForm from './components/PersonCardForm';
import Api from '../../../../util/api';
import PersonCardForm from '../../../tickets/externalProviders/components/PersonCardForm';

const STATUS_LABELS = {
  ACTIVE: 'Active',
  SENDING: 'Sent',
  RECEIVING: 'Receiving',
};

const formatDate = (iso) => {
  if (!iso) return '--';
  return new Date(iso).toLocaleString([], {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const EventTicketsTable = ({
  event,
  defaultOpen,
  onShare,
  onCancelShare,
  StatusLabel,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div style={{ marginBottom: 12 }}>
      <div
        onClick={() => setIsOpen((prev) => !prev)}
        role="button"
        tabIndex={0}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'baseline',
          padding: '10px 12px',
          background: '#f5f5f5',
          borderRadius: isOpen ? '6px 6px 0 0' : 6,
          border: '1px solid rgba(0,0,0,0.08)',
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        <span>
          <span style={{ marginRight: 8 }}>{isOpen ? '▾' : '▸'}</span>
          <strong>{event.name}</strong>
        </span>
        <span style={{ fontSize: 13, color: '#666' }}>
          {formatDate(event.startsAt)} — {formatDate(event.endsAt)} ·{' '}
          {event.tickets.length} ticket{event.tickets.length !== 1 ? 's' : ''}
        </span>
      </div>
      <Collapse isOpen={isOpen}>
        <Table responsive striped className="mb-0">
          <thead>
            <tr>
              <th>Field</th>
              <th>Row</th>
              <th>Seat</th>
              <th>Price Group</th>
              <th>
                {StatusLabel === STATUS_LABELS.RECEIVING
                  ? 'Receiving from'
                  : StatusLabel === STATUS_LABELS.SENDING
                    ? 'Sent to'
                    : 'Provider'}
              </th>
              <th />
              <th />
            </tr>
          </thead>
          <tbody>
            {event.tickets.map((ticket) => (
              <tr key={ticket.id}>
                <td>{ticket?.extraData?.field || ticket?.field || '--'}</td>
                <td>{ticket?.extraData?.row || ticket?.row || '--'}</td>
                <td>{ticket?.extraData?.seat || ticket?.seat || '--'}</td>
                <td>
                  {ticket?.extraData?.priceGroup || ticket?.priceGroup || '--'}
                </td>
                <td>
                  {StatusLabel === STATUS_LABELS.RECEIVING
                    ? ticket?.ticketSharing?.fromUser?.phoneNumber
                    : StatusLabel === STATUS_LABELS.SENDING
                      ? ticket?.ticketSharing?.toUser?.phoneNumber
                      : ticket.externalProvider}
                </td>
                <td>
                  {ticket.ticketSharing && (
                    <Badge color="warning">Pending share</Badge>
                  )}
                </td>
                <td>
                  {!ticket.ticketSharing ? (
                    ticket.shareable && (
                      <Button
                        onClick={() => onShare(ticket)}
                        size="sm"
                        color="primary p-1 m-0"
                      >
                        Share
                      </Button>
                    )
                  ) : (
                    <Button
                      onClick={() => onCancelShare(ticket)}
                      size="sm"
                      color="danger p-1 m-0"
                    >
                      Cancel share
                    </Button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Collapse>
    </div>
  );
};

const ExternalTickets = ({ user, phone, provider, isActive }) => {
  const [ticketGroups, setTicketGroups] = useState({
    ACTIVE: [],
    SENDING: [],
    RECEIVING: [],
  });
  const [initialLoading, setInitialLoading] = useState(false);
  const [syncing, setSyncing] = useState(false);
  const [shareTicket, setShareTicket] = useState(null);

  const loadCachedTickets = async () => {
    setInitialLoading(true);
    try {
      const response = await Api.tickets.myFutureTickets();
      setTicketGroups(response.data);
    } catch (error) {
      toast.error('Error fetching tickets');
    } finally {
      setInitialLoading(false);
    }
  };

  // useEffect(() => {
  //   if (!isActive) return;
  //   syncTickets();
  // }, [user, isActive]);

  const syncTickets = async () => {
    setSyncing(true);
    try {
      const response = await Api.tickets.getAdminUserTickets(
        user,
        provider,
        phone
      );
      console.log('response---', response);
      setTicketGroups(response);
    } catch (error) {
      toast.error('Error syncing tickets');
    } finally {
      setSyncing(false);
    }
  };

  React.useEffect(() => {
    let isMounted = true;

    const init = async () => {
      // await loadCachedTickets();
      if (isMounted) syncTickets();
    };

    init();

    return () => {
      isMounted = false;
    };
  }, [user]);

  const handleShare = (ticket) => {
    setShareTicket(ticket);
  };

  const handleCancelShare = async (ticket) => {
    try {
      const payload = {
        ticketSharings: [
          {
            id: ticket.ticketSharing.id,
            action: 'CANCELLED',
          },
        ],
      };

      await Api.tickets.handleShareTickets(payload);
      toast.success('ticket share cancelled');
      const response = await Api.tickets.myFutureTickets();
      setTicketGroups(response.data);
    } catch (e) {
      toast.error('ticket share cancellation failed');
    }
  };
  // const closeShareModal = () => {};
  const closeShareModal = () => setShareTicket(null);

  const sortEvents = (events) =>
    [...events].sort((a, b) => new Date(a.startsAt) - new Date(b.startsAt));

  const hasAnyTickets =
    ticketGroups?.ACTIVE.length > 0 ||
    ticketGroups?.SENDING.length > 0 ||
    ticketGroups?.RECEIVING.length > 0;

  return (
    <Container>
      <div className="card__title my-2 d-flex align-items-center justify-content-between">
        {/* <h3 className="page-title">Tickets</h3> */}
        {syncing && (
          <span
            className="text-muted d-flex align-items-center"
            style={{ fontSize: 13 }}
          >
            <Loading loading small />
            <span className="ml-1">Checking for new tickets…</span>
          </span>
        )}
      </div>

      {initialLoading ? (
        <Loading loading />
      ) : (
        <>
          {!hasAnyTickets && (
            <div className="text-center text-muted py-4">No tickets found</div>
          )}

          {Object.keys(STATUS_LABELS).map((status) => {
            const events = ticketGroups[status] || [];
            if (events.length === 0) return null;

            return (
              <div key={status} style={{ marginBottom: 24 }}>
                <h5 className="mb-2">{STATUS_LABELS[status]}</h5>
                {sortEvents(events).map((event, index) => (
                  <EventTicketsTable
                    key={event.id}
                    event={event}
                    defaultOpen={status === 'ACTIVE' && index === 0}
                    onShare={handleShare}
                    onCancelShare={handleCancelShare}
                    StatusLabel={STATUS_LABELS[status]}
                  />
                ))}
              </div>
            );
          })}
        </>
      )}

      <Modal isOpen={!!shareTicket} toggle={closeShareModal} centered>
        <ModalHeader toggle={closeShareModal}>
          Share Ticket: {shareTicket?.eventName}
          <br />
          field: {shareTicket?.field}, row:{shareTicket?.row}, seat:{' '}
          {shareTicket?.seat}
        </ModalHeader>
        <ModalBody>
          {shareTicket && (
            <PersonCardForm
              ticket={shareTicket}
              onClose={closeShareModal}
              setTicketGroups={setTicketGroups}
            />
          )}
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default ExternalTickets;
